import { getFee } from 'lib/firebase/utils';
import Table from 'components/shared/table';
import getFormattedDate from 'lib/utils/getFormattedDate';
import { formatPriceByStoreLocale } from 'lib/shopify';

const Paid = ({ salon, global, locale }) => {
  const PAID_STATUS_TABLE = {
    title: global.payments['paymentsTable-Title']?.text,
    description: null,
    linktext: null,
    action: null,
    infotext: global.tables['tables-DateExplanation']?.text,
    columns: [
      {
        label: global.account['salonAccount-Amount']?.text,
        icon: null,
        id: 'amount',
      },
      {
        label: `${global.tables['tables-Order']?.text} #`,
        icon: null,
        id: 'orderNo',
      },
      {
        label: global.tables['tables-Date']?.text,
        icon: 'info', // This represents icon type and className
        id: 'date',
      },
    ],
    rows: salon.orders
      .filter(({ status }) => status === 'paid')
      // eslint-disable-next-line
      .map(({ amount, orderNo, paid_on, handleCost }) => ({
        amount: formatPriceByStoreLocale({
          locale,
          price: getFee(amount, salon.salonKickbackfeeMargin, handleCost),
        }),
        orderNo,
        // eslint-disable-next-line camelcase
        date: paid_on
          ? getFormattedDate(paid_on, 'ISO')
          : global.account['salonAccount-DateNotAvailable']?.text,
      }))
      // eslint-disable-next-line
      .sort((a, b) => new Date(a.date) - new Date(b.date)),
  };

  return (
    <div>
      <Table salon={salon} table={PAID_STATUS_TABLE} showOrder />
    </div>
  );
};

export default Paid;
